import { useEffect, useMemo, useState } from "react";
import { UIDropDown } from "./UIComponents";
import "./LocaleSelector.css";

function LocaleSelector({
  localeList: propLocaleList,
  selectedLocale,
  onLocaleChange,
}) {
  const localeOptions = useMemo(
    () => (propLocaleList && propLocaleList.length > 0 ? propLocaleList : []),
    [propLocaleList],
  );
  const [selectedValue, setSelectedValue] = useState(
    propLocaleList && propLocaleList.length > 0 ? selectedLocale : ""
  );

  useEffect(() => {
    if (
      (!selectedLocale || selectedLocale === "") &&
      localeOptions.length > 0
    ) {
      const defaultLocale = localeOptions[0];
      setSelectedValue(defaultLocale);
      onLocaleChange({ target: { value: defaultLocale } });
    } else {
      setSelectedValue(selectedLocale);
    }
  }, [localeOptions, selectedLocale, onLocaleChange]);

  const isSelected = selectedValue && selectedValue !== "";

  return (
    <div className="d-flex flex-row align-items-center justify-content-start mb-3 pl-3">
      <span className="title-prompts">Select Application Locale:</span>
      <div
        className={`locale-dropdown-wrapper ${isSelected ? "locale-selected" : ""}`}
      >
        <UIDropDown
          list={localeOptions}
          value={selectedValue}
          onChange={onLocaleChange}
          minWidth="100%"
          menuClassName="locale-menu-paper"
          enableSearch={true}
          selectedStyle={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: "#343a40 !important",
              color: "white !important",
              width: "max-content !important",
              minWidth: "0 !important",
              position: "relative !important",
            },
            "& .MuiSelect-select": {
              backgroundColor: "#343a40 !important",
              color: "white !important",
              padding: "7px 30px 7px 15px !important",
              width: "auto !important",
              minWidth: "95px !important",
              whiteSpace: "nowrap !important",
              overflow: "visible !important",
              textOverflow: "clip !important",
              textAlign: "center !important",
            },
            "& .MuiSelect-icon": {
              color: "white !important",
              position: "absolute !important",
              right: "5px !important",
              left: "auto !important",
              margin: "0 !important",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent !important",
            },
          }}
        />
      </div>
    </div>
  );
}

export default LocaleSelector;
